import { NeoState } from '../Reducers.interface';

export const selectCurrentProvider = (state: NeoState) => state.provider.current?.provider;
export const selectCurrentProviderLoading = (state: NeoState) => state.provider.current?.loading;
export const selectCurrentProviderError = (state: NeoState) => state.provider.current?.error;
